import hubLayout from 'styles/css/hubLayout.module.css';
import styled from "styled-components";
import { useEffect } from 'react';

const InfoSection = styled.div`  
  .info_wrap {
    padding: 1.5rem 0.5rem;
  }
  
  .info_title {
    font-size: 1.125rem;
    margin-bottom: 1rem;
    padding: 0.5rem 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    border-bottom: 1px solid #121212;
  }
`;

function StoreGuide() {
  const searchParams = new URLSearchParams(window.location.search);
  const kakaoMonitorHandled = searchParams.get('kakao_monitor_handled');

  function openAosStore() {
    window.open(`market://details?id=com.aslan.customer&kakao_monitor_handled=${encodeURIComponent(kakaoMonitorHandled || "")}`);
    // setTimeout(() => {
    //   actionApp?.close();
    // }, 2000); // 2초 후 닫기
  }
  function openIosStore() {
    window.location.href = 'https://apps.apple.com/us/app/focus-view/id6742397189';
  }
  useEffect(() => {
    window.open(`focus-view://open?kakao_monitor_handled=${encodeURIComponent(kakaoMonitorHandled || "")}`);
  }, [kakaoMonitorHandled]);
  return (
    <InfoSection style={{ overflowY: "auto", height: "100%" }}>
      <div className={`${hubLayout.acc__cnt}`}>
        <h2 className={`${hubLayout.cnt_title}`} style={{ textAlign: "center" }}>
          <img src="/image/FOCUSAI_Blue_Black.png" style={{ width: "50%" }} alt='FOCUSAI_Blue_Black' />
        </h2>
        <div className="info_wrap">
          <div className="info_title">
            <h4>스토어 안내</h4>
          </div>
          <div className={`${hubLayout.btn_group}`} style={{ margin: '4rem 0' }}>
            <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.blue}`} onClick={openIosStore}>IOS APP Download</button>
          </div>
          <div className={`${hubLayout.btn_group}`} style={{ margin: '4rem 0' }}>
            <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.blue}`} onClick={openAosStore}>Android APP Download</button>
          </div>
        </div>
      </div>
    </InfoSection>
  );
}

export default StoreGuide;